import { DonorStatus, RetiredReasons } from 'gql/types';
import { donorStatusSchema } from 'modules/donor/schemas';
import { getTranslation } from 'utils/getTranslation';
import * as yup from 'yup';

import { DonorStatusField } from './fields';

const { status, RetiredClarification, RetiredReason } = DonorStatusField;

type DonorStatusSectionSchemaType = {
  status: DonorStatus;
  retiredReason?: RetiredReasons | null;
  retiredClarification?: string | null;
};

const t = getTranslation('donor.ValidationErrors');

const donorStatusSectionSchema: yup.SchemaOf<DonorStatusSectionSchemaType> =
  yup.object({
    [status]: donorStatusSchema.required(),
    [RetiredClarification]: yup
      .string()
      .max(
        255,
        t('shorterThan', { max: 255, field: t('retiredClarification') })
      )
      .optional()
      .nullable(),
    [RetiredReason]: yup
      .mixed<RetiredReasons>()
      .oneOf([...Object.values(RetiredReasons), null])
      .when(status, {
        is: DonorStatus.Retired,
        then: (schema) =>
          schema.required(t('required', { field: t('RetiredReason') })),
        otherwise: (schema) => schema.optional(),
      })
      .nullable(),
  });

export { donorStatusSectionSchema };
export type { DonorStatusSectionSchemaType };
